module.exports = __webpack_public_path__ + "img/djtd.264d1ef4.png";